import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { GET_DIGITAL_CARD_STATES, GET_DIGITAL_CARD_STATES_ERROR, GET_DIGITAL_CARD_STATES_SUCCESS } from '../../actions.js';

function* getDigitalCardStates({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/benefit-type/digital/card-states`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_DIGITAL_CARD_STATES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_DIGITAL_CARD_STATES_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_DIGITAL_CARD_STATES_ERROR, payload: error });
  }
}

export function* watchGetDigitalCardStates() {
  yield takeEvery(GET_DIGITAL_CARD_STATES, getDigitalCardStates);
}

function* getDigitalCardStatesSaga() {
  yield all([fork(watchGetDigitalCardStates)]);
}

export default getDigitalCardStatesSaga;
